import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Session from "supertokens-web-js/recipe/session";
import { EmailVerificationClaim } from "supertokens-web-js/recipe/emailverification";
import { Loader2} from "lucide-react";

async function shouldLoadRoute() {
    if (await Session.doesSessionExist()) {
        let validationErrors = await Session.validateClaims();
        return validationErrors.every(err => err.id !== EmailVerificationClaim.id);
    }
    return false;
}

export default function ProtectedRoute({ children }) {
    const [isAllowed, setIsAllowed] = useState(null);

    useEffect(() => {
        async function verifyAccess() {
            setIsAllowed(await shouldLoadRoute());
        }
        verifyAccess();
    }, []);

    if (isAllowed === null) return( 
    <div className="flex items-center justify-center h-screen w-screen">
        <Loader2 className="animate-spin h-16 w-16 text-gray-500" />
      </div>);
    return isAllowed ? children : <Navigate to="/" />;
}
